module.exports = __webpack_public_path__ + "img/34.c49f7b63.jpg";